module.exports = __webpack_public_path__ + "img/search.5eec060c.svg";